import { getRoles, getUserRoles } from "../services/auth";
import { IRole, IRoles, IUserRole, IUserRoles } from "../models/IUserRoles";

export const checkIsSuperAdmin = async (userId: string): Promise<boolean> => {
  try {
    const roleListResponse = await getRoles();
    const roles: IRoles = roleListResponse.data;
    const userRoleResponse= await getUserRoles(userId);
    const userRoles:IUserRoles=userRoleResponse.data;
    const SuperAdmin = "8a4f28f7-2b6c-ef11-986b-5cef2cd6e8d8";

     // return roles.some((role) => role.id === "SuperAdmin" && role.id === userRole.id);
     return userRoles.some(role => role.role.id === SuperAdmin);

  } catch (err) {
    console.error("Rol kontrolü hatası:", err);
    return false;
  }
};